import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { ContractsStore } from "../../store/modules/contracts";
import { Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import i18n from "@/i18n";
import { OperationVue } from "../operations/OperationVue";
import IOperationService from "../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { ServerCommandsModel } from "../../models/serverCommands/serverCommandsModel";
import currencyFilter from "../../filters/currency.filter";
import { ContractModel } from "../../models/contracts/contractModel";

/**
 *  Класс для компоненты модального окна СБП заявок на перевод.
 */
export class ServerCommandsModalVue extends OperationVue {

  /** Входные параметры */
  @Prop() props!: any;

  /** флаг окна */
  modalShow: boolean = false;

  /**
 * Значение суммы операции
 * @returns {string} - сумма + значение валюты.
 */
  get Sum(): string {
    return this.$options.filters.sum(this.props?.Message.split('|')[2], false, currencyFilter('RUR'));
  }

  /**
 * Значение комиссии операции
 * @returns {string} - комиссия + значение валюты.
 */
  get Tariff(): string {
    return this.$options.filters.sum(this.props?.Message.split('|')[3], false, currencyFilter('RUR'));
  }

  /**
 * Комментарий к операции
 * @returns {string} - комментарий
 */
  get Comment(): string {
    return this.props?.Message.split('|')[4];
  }

  /**
 * Идентификатор банка
 * @returns {string} - Идентификатор банка
 */
  get bankId(): string {
    return this.props?.Message.split('|')[0];
  }

  /**
 * Логотип банка
 * @returns {string} - ссылка на лого банка.
 */
  get bankLogo(): string {
    return this.props?.Message.split('|')[1];
  }

  /**
 * Заголовок окна
 * @returns {string} - Заголовок окна
 */
  get modalTitle(): string {
    if ((this.OperationModel as ServerCommandsModel).commandState === 2)
      return i18n.t(`common.serverCommands.bankSelectTitle`).toString();;
    return i18n.t(`main.settings.sbpServerCommandReq`).toString();
  }

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /**
 * Хранилище данных пользователя
 * @returns {PersonStore}
 */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  /**
 * Список счетов подходящих для СБП.
 * @returns {Array<ContractModel>} - массив счетов.
 */
  get contractsSBP(): Array<ContractModel> {
    return this.contractsStore.contracts.getSbpInContracts();
  }

  /** Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.ServerCommandsService);
    this.OperationModel = (await this.service.init(
      this.configStore,
      this.personStore,
      this.contractsStore,
      {
        id: this.props.Id,
        bankId: this.bankId,
        bankLogo: this.bankLogo
      }
    )) as ServerCommandsModel;
    this.loading = false;
  }

  /** Отмена операции */
  async destroyForm(): Promise<void> {
    if ((this.OperationModel as ServerCommandsModel).commandState !== 2) {
      (this.OperationModel as ServerCommandsModel).commandState = -1;
      this.OperationModel = await this.service.execute(this.OperationModel);
    }
    await this.clearForm();
    this.$emit("hideSelf");
  }
}
